export const Footer = () => {
  return (
    <footer className="relative mt-24 border-t border-gold/15 bg-obsidian-2" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <span className="font-serif text-3xl font-bold gold-text">Tashora</span>
          <p className="text-sm text-muted-foreground mt-4 max-w-sm leading-relaxed">
            Handwoven heritage sarees, reimagined for the modern connoisseur. Try any drape
            on yourself with our AI Virtual Draping Studio before you buy.
          </p>
          <p className="caption mt-6 mb-2">About Us</p>
          <p className="text-sm text-muted-foreground max-w-sm leading-relaxed">
            Born from a love of India's timeless weaves, Tashora partners directly with master
            weavers across Varanasi, Kanchipuram and Bengal to bring you authentic, certified
            sarees — paired with AI so you can see every drape on yourself before it's yours.
          </p>
        </div>
        <div>
          <p className="caption mb-4">Atelier</p>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>Banarasi Silk</li>
            <li>Kanjeevaram</li>
            <li>Tashore Silk</li>
            <li>Bonolata Silk</li>
            <li>Chikankari</li>
            <li>Begumpuri</li>
            <li>Mall Cotton</li>
            <li>Chanderi Cotton</li>
            <li>Georgette</li>
          </ul>
        </div>
        <div>
          <p className="caption mb-4">Care</p>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><a href="/track" data-testid="footer-track-link" className="hover:text-gold transition-colors">Track your order</a></li>
            <li>Insured shipping at actual cost</li>
            <li>Authenticity certificate</li>
            <li>Open-package policy — check before you accept</li>
            <li>AI Drape Assistance</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-gold/10 py-5 text-center text-xs text-muted-foreground/70">
        © {new Date().getFullYear()} Tashora Heritage Atelier · Woven with love in India
      </div>
    </footer>
  );
};
